export const REVIEW_TASKS_INDEX = Object.freeze({
  nothing: 0,
  superAdmin: 1,
  photoMatch: 2,
  validPoa: 4,
  requestForAutoReviewSent: 8,
  requestForAutoReviewApproved: 16,
  accreditedInvestor: 32,
  nonLatinDocs: 64
})



// WEBPACK FOOTER //
// ./src/js/const/review_tasks.const.js